const PERFILES_CERTIFICACION_POLICIAL = {
  DP_ADMINISTRADOR: 'DP_ADMINISTRADOR',
  DP_CUP: 'DP_CUP',
  DP_CONVOCATORIAS_CONDECORACIONES: 'DP_CONVOCATORIAS_CONDECORACIONES',
  DP_EVALUACIONES: 'DP_EVALUACIONES',
  DP_CONTROL_EVALUACIONES: 'DP_CONTROL_EVALUACIONES',
  DP_CONDECORACIONES_EVALUACIONES: 'DP_CONDECORACIONES_EVALUACIONES',
}

export const PERFILES = {
  Armeria: 'Armeria',
  ARMERIA_LOC: 'ARMERIA_LOC',
  ['ARMERIA_PASE DE LISTA']: 'ARMERIA_PASE_LISTA',
  ['ARMERIA_PERSONAL_LOC']: 'ARMERIA_PERSONAL_LOC',
  ['ARMERIA_CATALOGOS E INVENTARIO ARMAS']: 'ARMERIA_CATALOGO_INVENTARIO_ARMAS',
  ['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS']: 'ARMERIA_CATALOGO_INVENTARIO_ACCESORIOS',

  Equipamiento: 'Equipamiento',
  EQUIPAMIENTO_ADMINISTRADOR: 'EQUIPAMIENTO_ADMINISTRADOR',

  Profesionalización: 'Profesionalización',
  IFCSP_RECLUTAMIENTO: 'IFCSP_RECLUTAMIENTO',
  IFCSP_ADMINISTRADOR: 'IFCSP_ADMINISTRADOR',
  IFCSP_PROFESIONALIZACION: 'IFCSP_PROFESIONALIZACION',

  ...PERFILES_CERTIFICACION_POLICIAL,

  ['Enlace C3']: 'Enlace C3',
  ['ENLACE_C3_ADMINISTRADOR']: 'ENLACE_C3_ADMINISTRADOR',
  ['ENLACE_C3_CAPTURA_RESULTADOS']: 'ENLACE_C3_CAPTURA_RESULTADOS',
  ['ENLACE_C3_CAPTURA_EXPEDIENTE']: 'ENLACE_C3_CAPTURA_EXPEDIENTE',

  ['Recursos Humanos']: 'Recursos Humanos',
  RH_ADMINISTRADOR: 'RH_ADMINISTRADOR',
  ['RH_TRAMITES ADMINISTRATIVOS']: 'RH_TRAMITES_ADMINISTRATIVOS',
  ['RH_CAMBIO DE ESTATUS/ADSCRIPCION']: 'RH_CAMBIO_ESTATUS/ADSCRIPCION',
  ['RH_REGISTRO DE PERSONAL']: 'RH_REGISTRO_PERSONAL',

  REP_ADMINISTRADOR: 'REP_ADMINISTRADOR',
  REP_REGISTRO: 'REP_REGISTRO',
  REP_CREDENCIALIZACION: 'REP_CREDENCIALIZACION',
  ['Personal / Site']: 'Personal/Site',
  REP_BIOMETRIA: 'REP_BIOMETRIA',

  ['Asuntos Internos']: 'Asuntos Internos',
  ['Consejo de Honor y Justicia']: 'Consejo de Honor y Justicia',
  Policia: 'Policia',
  Candidato: 'Candidato',

  COMISARIA_CAPTURA: 'COMISARIA_CAPTURA',
  COMISARIA_SUPERVISOR: 'COMISARIA_SUPERVISOR',
  ['ADMINSITRADOR GENERAL']: 'ADMINSITRADOR GENERAL',
  ['USUARIO_ANALITICA']: 'USUARIO_ANALITICA',
  ['ANALISTA_ANALITICA']: 'ANALISTA_ANALITICA',
}

export const MODULOS = {
  ARMERIA: 'ARMERIA',
  EQUIPAMIENTO: 'EQUIPAMIENTO',
  PROFESIONALIZACION: 'PROFESIONALIZACION',
  DESARROLLO_POLICIAL: 'DESARROLLO_POLICIAL',
  ENLACE_C3: 'ENLACE_C3',
  RECURSOS_HUMANOS: 'RECURSOS_HUMANOS',
  REGISTRO_PERSONAL: 'REGISTRO_PERSONAL',
  CONSULTA_PERSONAL: 'CONSULTA_PERSONAL',
  ENLACE: 'ENLACE',
  POLICIA: 'POLICIA',
}

export const MODULOS_PERFILES = {
  [MODULOS.ARMERIA]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.Armeria,
    PERFILES.ARMERIA_LOC,
    PERFILES['ARMERIA_PASE DE LISTA'],
    PERFILES['ARMERIA_PERSONAL_LOC'],
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ARMAS'],
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS'],
  ],
  [MODULOS.EQUIPAMIENTO]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.Equipamiento,
    PERFILES.EQUIPAMIENTO_ADMINISTRADOR,
  ],
  [MODULOS.PROFESIONALIZACION]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.Profesionalización,
    PERFILES.IFCSP_RECLUTAMIENTO,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.IFCSP_PROFESIONALIZACION,
  ],
  [MODULOS.DESARROLLO_POLICIAL]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_EVALUACIONES,
    PERFILES.DP_CONVOCATORIAS_CONDECORACIONES,
    PERFILES.DP_CUP,
    PERFILES.DP_CONTROL_EVALUACIONES,
    PERFILES.DP_CONDECORACIONES_EVALUACIONES,
  ],
  [MODULOS.ENLACE_C3]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES['Enlace C3'],
    PERFILES['ENLACE_C3_ADMINISTRADOR'],
    PERFILES['ENLACE_C3_CAPTURA_RESULTADOS'],
    PERFILES['ENLACE_C3_CAPTURA_EXPEDIENTE'],
    PERFILES['ENLACE_C3_CAPTURA_RESULTADOS'],
  ],
  [MODULOS.RECURSOS_HUMANOS]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_TRAMITES ADMINISTRATIVOS'],
    PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION'],
    PERFILES['RH_REGISTRO DE PERSONAL'],
  ],
  [MODULOS.REGISTRO_PERSONAL]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_REGISTRO,
    PERFILES.REP_CREDENCIALIZACION,
    PERFILES['Personal / Site'],
    PERFILES.REP_BIOMETRIA,
  ],
  [MODULOS.CONSULTA_PERSONAL]: [PERFILES['ADMINSITRADOR GENERAL']],
  [MODULOS.ENLACE]: PERFILES['ADMINSITRADOR GENERAL'],
}
export const FEATURES = {
  CANDIDATOS: 'CANDIDATOS',
  CONTROL_ASPIRANTES: 'CONTROL_ASPIRANTES',
  CAPACITADORES: 'CAPACITADORES',
  AULAS: 'AULAS',
  CURSOS: 'CURSOS',
  CURSOS_PROGRAMADOS: 'CURSOS_PROGRAMADOS',
  SUGERENCIA_CURSOS: 'SUGERENCIA_CURSOS',
  FATIGA_ENTRADA_SALIDA_ARMA: 'FATIGA_ENTRADA_SALIDA_ARMA',
  REGISTRO_LOC: 'REGISTRO_LOC',
  INVENTARIO_ITEMS: 'INVENTARIO_ITEMS',
  ASIGNACION_ITEMS_PERSONAL: 'ASIGNACION_ITEMS_PERSONAL',
  CONVOCATORIAS: 'CONVOCATORIAS',
  SALIR_APLICACION: 'SALIR_APLICACION',
  //desarrollo profesional
  CONDECORAR_ELEMENTO: 'CONDECORAR_ELEMENTO',
  REALIZAR_EVALUACION_DESEMPEÑO_ACADEMICO: 'REALIZAR_EVALUACION_DESEMPEÑO_ACADEMICO',
  REALIZAR_EVALUACION_ANUAL: 'REALIZAR_EVALUACION_ANUAL',
  REALIZAR_EVALUACION_DESEMPEÑO: 'REALIZAR_EVALUACION_DESEMPEÑO',
  SUGERIR_CURSO: 'SUGERIR_CURSO',
  ASIGNACION_CUP: 'ASIGNACION_CUP',
  //enlace c3/aspirantes
  REGISTRO_RESULTADOS_C3: 'REGISTRO_RESULTADOS_C3',
  VISUALIZACION_RESULTADOS_C3: 'VISUALIZACION_RESULTADOS_C3',
  //enlace c3/PERSONAL
  REGISTRO_RESULTADOS_C3: 'REGISTRO_RESULTADOS_C3',
  TURNAR_C3: 'TURNA_C3',
  //RECURSOS HUMANOS/PERSONAL
  REGISTRO_NUEVO_PERSONAL: 'REGISTRO_NUEVO_PERSONAL',
  REGISTRAR_TRAMITE_ADMINISTRATIVO: 'REGISTRAR_TRAMITE_ADMINISTRATIVO',
  CAMBIO_DE_ESTATUS: 'CAMBIO_DE_ESTATUS',
  ASIGNACION_PUESTO_FUNCION_ADSCRIPCION: 'ASIGNACION_PUESTO_FUNCION_ADSCRIPCION',
  VER_ASISTENCIAS: 'VER_ASISTENCIAS',
  //PERSONAL/PREASPIRANTE
  CAPTURA_FOTOGRAFIA: 'CAPTURA_FOTOGRAFIA',
  CAPTURA_VOZ: 'CAPTURA_VOZ',
  CAPTURA_HUELLAS: 'CAPTURA_HUELLAS',
  REGISTRO_RESULTADO_CONSULTA_PREVIA: 'REGISTRO_RESULTADO_CONSULTA_PREVIA',
  REGISTRO_CUIP: 'REGISTRO_CUIP',
  //PERSONAL/PERSONAL
  REGISTRO_MEDIAS_FILACIONES: 'REGISTRO_MEDIAS_FILACIONES',
  REIMPRESION_CREDENCIAL: 'REIMPRESION_CREDENCIAL',
  REGISTRO_CREDENCIAL: 'REGISTRO_CREDENCIAL',
  REGISTRO_CUIP: 'REGISTRO_CUIP',
}

export const FEATURES_PERFILES = {
  [FEATURES.CANDIDATOS]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.IFCSP_RECLUTAMIENTO,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.CONTROL_ASPIRANTES]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.IFCSP_RECLUTAMIENTO,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.CAPACITADORES]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.IFCSP_PROFESIONALIZACION,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.AULAS]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.IFCSP_PROFESIONALIZACION,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.CURSOS]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.IFCSP_PROFESIONALIZACION,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.CURSOS_PROGRAMADOS]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.IFCSP_PROFESIONALIZACION,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.SUGERENCIA_CURSOS]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.IFCSP_PROFESIONALIZACION,
    PERFILES.IFCSP_ADMINISTRADOR,
    PERFILES.Profesionalización,
  ],
  [FEATURES.FATIGA_ENTRADA_SALIDA_ARMA]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.Armeria,
    PERFILES['ARMERIA_PASE DE LISTA'],
    PERFILES['ARMERIA_PERSONAL_LOC'],
  ],
  [FEATURES.REGISTRO_LOC]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.Armeria,
    PERFILES.ARMERIA_LOC,
    PERFILES['ARMERIA_PERSONAL_LOC'],
  ],
  [FEATURES.INVENTARIO_ITEMS]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.Armeria,
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS'],
    PERFILES['ARMERIA_PERSONAL_LOC'],
  ],
  [FEATURES.ASIGNACION_ITEMS_PERSONAL]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.Armeria,
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS'],
    PERFILES['ARMERIA_PERSONAL_LOC'],
  ],
  [FEATURES.CONVOCATORIAS]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_CONVOCATORIAS_CONDECORACIONES,
    PERFILES.DP_CONTROL_EVALUACIONES,
    PERFILES.DP_CONDECORACIONES_EVALUACIONES,
  ],
  [FEATURES.SALIR_APLICACION]: PERFILES['ADMINSITRADOR GENERAL'],
  //desarrollo profesional
  [FEATURES.CONDECORAR_ELEMENTO]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_CONVOCATORIAS_CONDECORACIONES,
    PERFILES.DP_CONTROL_EVALUACIONES,
    PERFILES.DP_CONDECORACIONES_EVALUACIONES,
  ],
  [FEATURES.REALIZAR_EVALUACION_DESEMPEÑO_ACADEMICO]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_EVALUACIONES,
    PERFILES.DP_CONTROL_EVALUACIONES,
    PERFILES.DP_CONDECORACIONES_EVALUACIONES,
  ],
  [FEATURES.REALIZAR_EVALUACION_ANUAL]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_CONTROL_EVALUACIONES,
    PERFILES.DP_CONDECORACIONES_EVALUACIONES,
    PERFILES.DP_EVALUACIONES,
  ],
  [FEATURES.REALIZAR_EVALUACION_DESEMPEÑO]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_CONTROL_EVALUACIONES,
    PERFILES.DP_CONDECORACIONES_EVALUACIONES,
    PERFILES.DP_EVALUACIONES,
  ],
  [FEATURES.SUGERIR_CURSO]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_EVALUACIONES,
    PERFILES.DP_CONTROL_EVALUACIONES,
    PERFILES.DP_CONDECORACIONES_EVALUACIONES,
  ],
  [FEATURES.ASIGNACION_CUP]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_EVALUACIONES,
    PERFILES.DP_CONTROL_EVALUACIONES,
    PERFILES.DP_CONDECORACIONES_EVALUACIONES,
    PERFILES.DP_CUP,
  ],
  //enlace c3/aspirantes
  [FEATURES.REGISTRO_RESULTADOS_C3]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES['Enlace C3'],
    PERFILES['ENLACE_C3_ADMINISTRADOR'],
    PERFILES['ENLACE_C3_CAPTURA_EXPEDIENTE'],
    PERFILES['ENLACE_C3_CAPTURA_RESULTADOS'],
  ],
  [FEATURES.TURNAR_C3]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES['Enlace C3'],
    PERFILES['ENLACE_C3_ADMINISTRADOR'],
    PERFILES['ENLACE_C3_CAPTURA_EXPEDIENTE'],
    PERFILES['ENLACE_C3_CAPTURA_RESULTADOS'],
  ],
  [FEATURES.VISUALIZACION_RESULTADOS_C3]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES['Enlace C3'],
    PERFILES['ENLACE_C3_ADMINISTRADOR'],
    PERFILES['ENLACE_C3_CAPTURA_EXPEDIENTE'],
    PERFILES['ENLACE_C3_CAPTURA_RESULTADOS'],
    PERFILES.DP_ADMINISTRADOR,
    PERFILES.DP_CONTROL_EVALUACIONES,
    PERFILES.DP_CONDECORACIONES_EVALUACIONES,
    PERFILES.DP_CUP,
    PERFILES.Armeria,
    PERFILES.ARMERIA_LOC,
    PERFILES['ARMERIA_PASE DE LISTA'],
    PERFILES['ARMERIA_PERSONAL_LOC'],
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ARMAS'],
    PERFILES['ARMERIA_CATALOGOS E INVENTARIO ACCESORIOS'],
  ],
  //RECURSOS HUMANOS/PERSONAL
  [FEATURES.REGISTRO_NUEVO_PERSONAL]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_REGISTRO DE PERSONAL'],
  ],
  [FEATURES.REGISTRAR_TRAMITE_ADMINISTRATIVO]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_TRAMITES ADMINISTRATIVOS'],
  ],
  [FEATURES.CAMBIO_DE_ESTATUS]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION'],
  ],
  [FEATURES.ASIGNACION_PUESTO_FUNCION_ADSCRIPCION]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES['Recursos Humanos'],
    PERFILES.RH_ADMINISTRADOR,
    PERFILES['RH_CAMBIO DE ESTATUS/ADSCRIPCION'],
  ],
  [FEATURES.VER_ASISTENCIAS]: [PERFILES['ADMINSITRADOR GENERAL'], PERFILES.RH_ADMINISTRADOR],
  //PERSONAL/PREASPIRANTE
  [FEATURES.CAPTURA_FOTOGRAFIA]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_BIOMETRIA,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.CAPTURA_VOZ]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_BIOMETRIA,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.CAPTURA_HUELLAS]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_BIOMETRIA,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.REGISTRO_RESULTADO_CONSULTA_PREVIA]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_REGISTRO,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.REGISTRO_CUIP]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_REGISTRO,
    PERFILES['Personal / Site'],
  ],
  //PERSONAL/PERSONAL
  [FEATURES.REGISTRO_MEDIAS_FILACIONES]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_BIOMETRIA,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.REIMPRESION_CREDENCIAL]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_CREDENCIALIZACION,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.REGISTRO_CREDENCIAL]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_CREDENCIALIZACION,
    PERFILES['Personal / Site'],
  ],
  [FEATURES.REGISTRO_CUIP]: [
    PERFILES['ADMINSITRADOR GENERAL'],
    PERFILES.REP_ADMINISTRADOR,
    PERFILES.REP_REGISTRO,
    PERFILES['Personal / Site'],
  ],
}
